<template>
  <div class="content">
    <h1 class="is-1">{{ $t("hello") }}</h1>
    <p>{{ $t("message") }}</p>
  </div>
</template>

<script>
import { i18nMixin } from "@/vue/mixins/i18nMixin";

export default {
  name: "home",
  mixins: [i18nMixin]
};
</script>

<style lang="scss" scoped></style>

<i18n>
{
    "en": {
        "pageTitle": "Home",
        "hello": "Hi!",
        "message": "This is my portfolio and CV. You visit different pages via either header or footer."
    },
    "fi": {
        "pageTitle": "Home",
        "hello": "Terve!",
        "message": "Tämä sivu on portfolioni / CV:ni. Ylä- ja alapalkeista voit vierailla eri sivuilla."
    }
}
</i18n>
